import { render, staticRenderFns } from "./app-standalone.vue?vue&type=template&id=a46b04be&"
import script from "./app-standalone.vue?vue&type=script&lang=js&"
export * from "./app-standalone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports